import { styled } from "@mui/material/styles";
import { DataGridPro } from "@mui/x-data-grid-pro";


export const CustomDataGrid = styled(DataGridPro)({
  "& .MuiDataGrid-cell": {
    color: "black",
    fontFamily: "Poppins",
  },
  '& .MuiDataGrid-columnHeader': {
    backgroundColor: "#a7c4dc",
    // color: "red",
    fontFamily: "Poppins",
    // backgroundColor: "#ff0000"
  },
  '& .MuiDataGrid-columnHeaderTitle': {
    fontWeight: "700 !important",
    textTransform: "uppercase"
  },
  "& .MuiDataGrid-row": {
    '&:hover': {
      cursor: "pointer",
      backgroundColor: "#F5F5F5",
    }
  },
});